export default function () {
  return {
    all: null,
  };
}
